import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import { theme } from '@styles/theme';

export type StepperSimpleProps = {
  totalSteps: number;
  activeIndex: number;
  items?: Array<{ route: string }>;
};

export const StepperSimple = ({ items = [], activeIndex, totalSteps }: StepperSimpleProps) => {
  const navigate = useNavigate();

  return (
    <Dots aria-label="Dots">
      {Array.from({ length: totalSteps }, (_, index) => (
        <Fragment key={index}>
          <Item
            onClick={() => items[index]?.route && navigate(items[index].route!)}
            data-active={index === activeIndex}
          />
        </Fragment>
      ))}
    </Dots>
  );
};

const Dots = styled.ol({
  height: '1.5rem',
  margin: 0,
  padding: 0,
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: theme.space[6],
});

const Item = styled.li({
  backgroundColor: theme.color.uiTrans10,
  borderRadius: '50%',
  height: '0.5rem',
  width: '0.5rem',
  transition: 'color 150ms ease-out',

  '&[data-active="true"]': {
    backgroundColor: theme.color.elementBlue100,
  },
});
